import isObject from 'lodash-es/isObject'
import omit from 'lodash-es/omit'

import { isValueStringType } from '../../utils/common'
import { getFormikFormSelectFieldWithCreationValidationSchema } from '../Formik'
import { getGooglePlaceLatLngFromGeocode } from '../Google'

function checkIsAddressSelectValueIsValid(value) {
  return isObject(value) && value.value
}

function getAddressSelectItemCoords(data) {
  const coords = getGooglePlaceLatLngFromGeocode(data)

  return {
    lattitude: coords.lat,
    longitude: coords.lng,
    widget_lattitude: coords.lat,
    widget_longitude: coords.lng,
  }
}

export function toAddressSelectItem(address) {
  return {
    label: address.description,
    value: address.place_id,
  }
}

export function toAddressSelectItems(items) {
  return items.map(toAddressSelectItem)
}

export function toAddressSelectItemWithCoordsFromGeocode(item, geocode) {
  return {
    ...item,
    ...getAddressSelectItemCoords(geocode),
  }
}

export function toAddressSelectItemFromReverseGeocode(address) {
  return {
    ...getAddressSelectItemCoords(address),
    label: address.formatted_address,
    value: address.place_id,
  }
}

export function getAddressSelectFieldWithCreationValidationSchema(props) {
  return getFormikFormSelectFieldWithCreationValidationSchema({
    ...props,
    checkIsValidObjectValue: checkIsAddressSelectValueIsValid,
  })
}

export function getCreateAddressPayloadFromSelectValue(value) {
  return isValueStringType(value)
    ? { value }
    : { ...omit(value, ['label', 'value']), value: value.label }
}
